 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		213: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"9cb953d","1":"0415698","2":"298dac8","3":"5228fc5","4":"5341f9a","5":"1e61efb","6":"9dfb5d4","7":"ef46c72","8":"2b123d8","9":"af73441","10":"4c622bf","11":"90babd5","12":"d8a8e76","13":"41fb339","14":"ff1ec3f","15":"0d720f1","16":"13a109f","17":"9fdec36","18":"630de43","19":"7a4cb4b","20":"887ee54","21":"7107180","22":"1a2bd49","23":"1ca69e5","24":"a992e5c","25":"1463cd9","26":"01ea9c5","27":"fdb34ed","28":"d208359","29":"e2b5abb","30":"e6eaeed","31":"2c0491e","32":"95d5dd9","33":"3f160c0","34":"c19ab13","35":"b39ffab","36":"31e6831","37":"845020a","38":"34635c2","39":"ec5eb3c","40":"6fe01c6","41":"fd76158","42":"94077b4","43":"2e74748","44":"5147b17","45":"6561fc5","46":"811210a","47":"10d9cc8","48":"cde6479","49":"baece23","50":"03008b7","51":"e649338","52":"f0ac041","53":"0a2a887","54":"948a2f8","55":"a68a29c","56":"ac98deb","57":"eb70962","58":"56c289c","59":"ec58670","60":"282f0d8","61":"0ef7f2b","62":"cf15677","63":"c3c7a78","64":"0823ae2","65":"572d63f","66":"3e3ddd4","67":"58f764a","68":"f1ff39c","69":"d72ea94","70":"d4c5dc0","71":"6bb2a70","72":"252ef1f","73":"a6d0a35","74":"0fd3b6a","75":"e236226","76":"c6bf1da","77":"29dfe85","78":"1bf6d4b","79":"f2ba059","80":"e115306","81":"dce7ad7","82":"f8836fb","83":"8ba0eae","84":"3abbda1","85":"3bcfbea","86":"0aeaa49","87":"63c526f","88":"c4b52ec","89":"36cd3a0","90":"3321f7a","91":"65b4086","92":"3463b67","93":"0479fe8","94":"94162cd","95":"d7ef511","96":"37e402a","97":"ba8d182","98":"20d1385","99":"dc72eb4","100":"b0a3a06","101":"15d0f4f","102":"5b5fa8a","103":"4f5fa7f","104":"2604038","105":"287d236","106":"b48c489","109":"7bf8ba6","110":"61069b1","111":"be8f59f","112":"ed74a3d","113":"b2f98bf","114":"ada13b5","115":"eb1b362","116":"cd6b00c","117":"dd79fc1","118":"fac05eb","119":"dd8ecc0","120":"84e44fe","121":"1d901ed","122":"09c0c64","123":"426be22","124":"ac60e52","125":"7460f9f","126":"dd71601","127":"92488b5","128":"1ac8a9c","129":"782519e","130":"fc96c59","131":"b567a0a","132":"74da37c","133":"9d34149","134":"edc6a31","135":"677fc87","136":"2526c66","137":"17156e1","138":"0edf46f","139":"e4f2427","140":"5225d55","141":"e2621da","142":"f64c1cc","143":"027f5cc","144":"f6e01b0","145":"5ae6c40","146":"88d5d1e","147":"82c126c","148":"f4021fa","149":"7363d22","150":"ff84c6a","151":"bd1113a","152":"198068c","153":"fafe54f","154":"eac5b77","155":"4d5ed11","156":"aa6aa3c","157":"32bbc73","158":"3c0f2c1","159":"0730e5c","160":"05d722e","161":"0149185","162":"f535b0b","163":"bc3f3d2","164":"0725a6b","165":"ab58e89","166":"3b926ba","167":"d8f59bc","168":"9545085","169":"8a64002","170":"ced1bc7","171":"efefaab","172":"7900d94","173":"8c556f5","174":"cd25ffa","175":"4685cd8","176":"ae87710","177":"cb6262a","178":"7e5bcfb","179":"321addc","180":"ad9101f","181":"cd37d50","182":"0ed5825","183":"03db1d3","184":"284e53f","185":"f8c75cc","186":"37bc320","187":"beaf1d5","188":"a9e9a0c","189":"24bd772","190":"2a6c1fd","191":"d73dda7","192":"edebf8a","193":"60b8002","194":"93e45ca","195":"dfc8ade","196":"83044ee","197":"c233e4a","198":"f835414","199":"59323cd","200":"cd7b11d","201":"75830b9","202":"19c35cb","203":"ee68a80","204":"b6523a3","205":"de73c89","206":"2268e25","207":"b50b22a","208":"ff9aefd","209":"87a0253","210":"ac68b3b","211":"710809e","212":"1dc26e7","215":"0e5bbb6","216":"1fab867","217":"3867983","218":"9831a04","219":"13d3f64","220":"bb2e594","221":"9ec809c","222":"6fc9737","223":"b5437ab","224":"3d16d83","225":"cebf8bc","226":"3756c35","227":"7a1dcce","228":"5ebb618","229":"d357fea","230":"6b502f4","231":"e7dd01d","232":"df79ff9","233":"d268b7e","234":"18124c1","235":"68451aa","236":"06cdb77","237":"f61e941","238":"29b230e","239":"4582835","240":"798da69","241":"4f8898e","242":"70e7881","243":"41e6d4a","244":"744f059","245":"9ab1f83","246":"ccded81","247":"da3b3b1","248":"1d11c54","249":"178e379","250":"c4ae634","251":"490a4d1","252":"59edd4e","253":"83b4427","254":"11196ee","255":"cea16f8","256":"d5a1609","257":"56d7ad6","258":"d7fb85c","259":"17270aa","260":"cad11af","261":"8631ff2","262":"2c34784","263":"35f643a","264":"9138b21","265":"0d59552","266":"223ac87","267":"b4384c6","268":"86ff457","269":"9993470","270":"d5f6658","271":"9a78ba6","272":"afabea9","273":"080fdd5","274":"9885c2d","275":"033792a","276":"f18a2dc","277":"3161013","278":"a11d331","279":"557d873","280":"17a5c31","281":"316ce71","282":"217af9d","283":"637022f","284":"b6e6613","285":"f28ff68","286":"96eaee6","287":"f2fb9ea","288":"50bf5ea","289":"7be3f0f","290":"9175d55","291":"42e46df","292":"c2d197b","293":"586c47c","294":"b546c31","295":"b7d3922","296":"fb2b373","297":"0fb1694","298":"03beaa7","299":"882240d","300":"3b11148","301":"54d43ee","302":"9033943","303":"343cb5a","304":"6afe6da","305":"b7a35a0","306":"109f319","307":"c84ad76","308":"f47d874","309":"0f174c6","310":"90fa657","311":"8d92f08","312":"6ee8450","313":"457ec0e","314":"4f03085","315":"90d93c6","316":"ddf43ab","317":"58a38c3","318":"b700306","319":"2149cfd","320":"c4bba90","321":"ec48eaf","322":"3213a78","323":"42b0e14"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1mf56q6wc1y19.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
